import React from 'react';
import { Button } from './ui/button';
import { heroData, statsData } from '../data/mock';
import { ArrowRight, CheckCircle, Zap, Shield, Award } from 'lucide-react';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Subtle Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a8ec5]/5 via-white to-[#cd2d31]/5"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-32 h-32 bg-[#0a8ec5]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-40 h-40 bg-[#cd2d31]/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content Column */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full px-4 py-2 text-sm font-medium text-gray-700">
                <CheckCircle className="w-4 h-4 text-green-500 mr-2" />
                Trusted Since 2002 • MSME Registered
              </div>
              
              <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
                <span className="bg-gradient-to-r from-[#0a8ec5] to-[#cd2d31] bg-clip-text text-transparent">
                  Clean Air
                </span>
                <br />
                <span className="text-gray-900">Solutions</span>
              </h1>
              
              <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
                {heroData.description}
              </p>
            </div>

            {/* Key Features */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm rounded-lg p-3 border border-gray-200">
                <Zap className="w-5 h-5 text-[#0a8ec5]" />
                <span className="text-sm font-medium text-gray-700">99.9% Efficiency</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm rounded-lg p-3 border border-gray-200">
                <Shield className="w-5 h-5 text-[#cd2d31]" />
                <span className="text-sm font-medium text-gray-700">20+ Years</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm rounded-lg p-3 border border-gray-200">
                <Award className="w-5 h-5 text-[#0a8ec5]" />
                <span className="text-sm font-medium text-gray-700">Global Projects</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
{/*               <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[#cd2d31] hover:bg-[#b02529] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:shadow-xl hover:scale-105 group"
              >
                {heroData.ctaText}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button> */}
              <Button 
                onClick={() => scrollToSection('projects')}
                variant="outline"
                className="border-[#0a8ec5] text-[#0a8ec5] hover:bg-[#0a8ec5] hover:text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:shadow-lg"
              >
                {heroData.ctaSecondary}
              </Button>
            </div>
          </div>

          {/* Visual Column */}
          <div className="relative">
            <div className="relative bg-white/40 backdrop-blur-sm rounded-3xl p-8 border border-gray-200 shadow-2xl">
              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-6">
                {statsData.map((stat, index) => (
                  <div key={index} className="text-center p-4 bg-white/60 rounded-xl border border-gray-100">
                    <div className="text-3xl font-bold text-[#0a8ec5] mb-2">
                      {stat.value}{stat.suffix}
                    </div>
                    <div className="text-sm text-gray-600 font-medium">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Featured Badge */}
              <div className="absolute -top-4 -right-4 bg-[#cd2d31] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                Industry Leader
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-[#0a8ec5]/20 rounded-full blur-2xl animate-pulse"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#cd2d31]/20 rounded-full blur-2xl animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;